import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.24), 0px 3px 12px rgba(0, 0, 0, 0.12);
`;
